// Hands off a landing-hero OTP start to `/early-access?card=otp` via
// sessionStorage so the gate opens on the verify card with email prefilled.

import { logger } from '@/lib/telemetry/logger';

export const WAITLIST_OTP_RESEND_COOLDOWN_MS = 60_000;

const STORAGE_KEY = 'morfi:waitlist-otp-handoff';

export type WaitlistOtpHandoff = {
  email: string;
  resendReadyAt: number;
};

export function storeWaitlistOtpHandoff(handoff: WaitlistOtpHandoff): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(handoff));
  } catch (err: unknown) {
    logger.warn('sessionStorage write failed for waitlist OTP handoff', {
      error: err instanceof Error ? err.message.slice(0, 200) : String(err),
    });
  }
}

export function consumeWaitlistOtpHandoff(): WaitlistOtpHandoff | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === null) {
      return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    const parsed = JSON.parse(raw) as {
      email?: string;
      resendReadyAt?: number;
    } | null;
    if (parsed === null || typeof parsed !== 'object') {
      return null;
    }
    const { email, resendReadyAt } = parsed;
    if (typeof email !== 'string' || typeof resendReadyAt !== 'number') {
      return null;
    }
    return { email, resendReadyAt };
  } catch (err: unknown) {
    logger.warn('sessionStorage read failed for waitlist OTP handoff', {
      error: err instanceof Error ? err.message.slice(0, 200) : String(err),
    });
    return null;
  }
}
